// © 2013 - 2024 Tinder, Inc., ALL RIGHTS RESERVED

import React, { memo } from 'react';
import { IconProps as Props } from '../types';

const SvgSelfieTrueOverlay: React.FC<Props> = (allProps) => {
  const { fill, primary, secondary, tertiary, quaternary, title, ...props } = allProps;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      focusable="false"
      role="img"
      {...props}
    >
      <title>{title}</title>
      <path
        fill={tertiary ?? fill ?? '#7C8591'}
        fillRule="evenodd"
        d="M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11m12-11c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12"
        clipRule="evenodd"
      />
      <path
        fill={primary ?? fill ?? '#000'}
        d="M23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11"
      />
      <g fill={secondary ?? fill ?? '#fff'}>
        <path d="M13.563 12.463a1.463 1.463 0 1 1-2.926 0 1.463 1.463 0 0 1 2.925 0" />
        <path
          fillRule="evenodd"
          d="M6.25 15.388c0 .807.655 1.462 1.463 1.462h8.775c.807 0 1.462-.655 1.462-1.462V9.864c0-.719-.583-1.301-1.302-1.301h-1.507c-.36 0-.68-.23-.794-.573a1.302 1.302 0 0 0-1.235-.89h-2.024c-.56 0-1.057.359-1.235.89a.837.837 0 0 1-.794.573H7.552A1.3 1.3 0 0 0 6.25 9.864zm8.288-2.925a2.437 2.437 0 1 1-4.875 0 2.437 2.437 0 0 1 4.874 0"
          clipRule="evenodd"
        />
      </g>
    </svg>
  );
};

const Memo = memo(SvgSelfieTrueOverlay);
export default Memo;
